// articleData.js
const articleData = [
    { title: 'Introduction to Frontend Development', author: 'Chinonso Okeke', link: 'https://example.com/article/frontend' },
    { title: 'Advanced Backend Techniques', author: 'Amina Yusuf', link: 'https://example.com/article/backend' },
    { title: 'Becoming a Fullstack Developer', author: 'Emeka Nwankwo', link: 'https://example.com/article/fullstack' },
    { title: 'UI/UX Best Practices', author: 'Ngozi Uche', link: 'https://example.com/article/uiux' },
    { title: 'Software Engineering Fundamentals', author: 'Tunde Balogun', link: 'https://example.com/article/engineering' },
    { title: 'Data Science Introduction', author: 'Zainab Mohammed', link: 'https://example.com/article/datascience' },
    // Add more articles as needed
  ];
  
  export default articleData;
  